module.exports = __webpack_public_path__ + "img/np_folder.e08b24b4.svg";